import React, { ReactNode } from "react";
import styled from "styled-components/native";
import { useIsFoldable } from "@navigations/utils/FoldableWrapper";
import { DefaultTheme } from "styled-components/native";

const { deviceWidth: width } = useIsFoldable();

type BannerProps = {
  children: ReactNode;
  bgColor?: string;
};

const Banner = ({ children, bgColor }: BannerProps) => {
  return <BannerContainer bgColor={bgColor}>{children}</BannerContainer>;
};

const BannerContainer = styled.View<{
  bgColor?: string;
}>`
  width: ${({ theme }: { theme: DefaultTheme }) =>
    theme.isLargeScreen ? "100%" : width};
  background-color: ${(props: any) => props.bgColor || "#FFF3CD"};
  align-items: center;
  justify-content: center;
`;

export default Banner;
